<template>
  <div class="">
    <v-app-bar
      app
      dark
      fixed
      style="background-color: var(--color-primary) !important"
    >
      <template v-slot:img="{ props }">
        <v-img v-bind="props" color="primary"></v-img>
      </template>

      <v-app-bar-nav-icon @click="toggleDrawer()"></v-app-bar-nav-icon>

      <v-toolbar-title class="font-sahel">{{ toolbarTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="logout">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on"> mdi-logout </v-icon>
          </template>
          <span>{{ $t("nav-logout") }}</span>
        </v-tooltip>

        <v-tooltip> </v-tooltip>
      </v-btn>

      <!-- <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
    </v-app-bar>

    <SideNavigation ref="navigation" @logout="logout" />

    <div class="pa-2">
      <router-view name="adminPlaceholder" class="homePlaceholder"></router-view>
    </div>
  </div>
</template>

<script>
import SideNavigation from "../components/navigation/SideNavigation.vue";

export default {
  components: {
    SideNavigation,
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    toggleDrawer() {
      ////console.log(this.$refs);
      this.$refs.navigation.toggleDrawer();
    },
    
    setSideNavigationArray() {
      //let arr = this.$store.state.permission.permissionList;
      ////console.log('setSideNavigationArray');
      this.$refs.navigation.setNavigationArray();
    },
  },
  data() {
    return {
      toolbarTitle: "",
    };
  },
  computed: {},
  mounted() {
    //this.GetAllStateForAdmin();
    //this.setSideNavigationArray();
    debugger
    if (this.$router.currentRoute.name == "adminHome") {
    this.$router.push({ name: "adminMainPage" });
    }
  },
  watch: {
    /*"$store.state.permission.permissionList": function () {
      this.setSideNavigationArray();
    },*/
    $route: {
      handler(to) {
        //document.title = to.meta.title || "Some Default Title";
        this.toolbarTitle =
          this.$t(to.meta.toolbarTitle) || this.$t("app-name") || "WebKart";
      },
    },
  },
};
</script>

<style>
.home {
  background-color: var(--background) !important;
}

.left {
  margin-right: auto;
  float: left;
}

.current-date {
  background-color: rgba(66, 166, 248, 0.308);
  padding: 5px 10px;
  border-radius: 50px;
  font-size: 0.875rem;
}

.homePlaceholder {
  padding-bottom: 30px;
}
</style>